module.exports = __webpack_public_path__ + "img/1f6e9.349c759.svg";